'use client';

import { useBoolean, useKey } from 'codekit';
import { motion } from 'framer-motion';
import { Image } from 'next-bricks';

import { Icon } from 'components/Icon';
import Section from '..';

import styles from './styles.module.css';

const YOUTUBE_VIDEO_ID = 'dtZTJk0hEq8';

function SectionPresentation() {
	// Boolean hooks
	const isWatching = useBoolean();

	// Event listeners
	useKey('Escape', isWatching.setFalse);

	return (
		<>
			<Section id="video" className={styles.container}>
				<motion.div
					className={styles.video}
					layoutId="video"
					onClick={isWatching.setTrue}
				>
					<div className={styles.thumbnail_overlay}>
						<div className={styles.play}>
							<div className={styles.play_inner}>
								<Icon
									name="Play"
									size={32}
									fill="var(--color-background)"
									stroke="var(--color-background)"
								/>
							</div>
						</div>
					</div>

					<Image
						src={`http://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/maxresdefault.jpg`}
						alt="Thumbnail do vídeo de apresentação"
						width={560 * 1.5}
						height={315 * 1.5}
						loading="lazy"
					/>
				</motion.div>
			</Section>

			{isWatching.value && (
				<motion.div
					className={styles.watch}
					initial={{
						background: 'transparent',
						backdropFilter: 'blur(0px)',
					}}
					animate={{
						background: 'rgba(0, 0, 0, 0.6)',
						backdropFilter: 'blur(10px)',
					}}
				>
					<div
						className={styles.watch__backdrop}
						onClick={isWatching.setFalse}
					/>

					<motion.div
						className={styles.video}
						layoutId="video"
						style={{ width: '80vw' }}
					>
						<iframe
							width={560}
							height={315}
							src={`https://www.youtube-nocookie.com/embed/${YOUTUBE_VIDEO_ID}?si=a9tcisZNtC4ekZyv`}
							title="YouTube video player"
							frameBorder={0}
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							referrerPolicy="strict-origin-when-cross-origin"
							allowFullScreen
						/>
					</motion.div>
				</motion.div>
			)}
		</>
	);
}

export default SectionPresentation;
